<template>
  <div>
    <service-pay-info></service-pay-info>
    <my-payment-list></my-payment-list>
  </div>
</template>

<script>
  import ServicePayInfo from "./components/ServicePayInfo";
  import MyPaymentList from "./MyPaymentList";
  export default {
    name: "Plan",
    components: {MyPaymentList, ServicePayInfo},
    created() {

    },
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="stylus" scoped>

</style>
